import { render, staticRenderFns } from "./RpeTtmChronicLoadChart.vue?vue&type=template&id=37021db8"
import script from "./RpeTtmChronicLoadChart.vue?vue&type=script&lang=js"
export * from "./RpeTtmChronicLoadChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports